import classNames from 'classnames'
import React, { useState } from 'react'
import SelectList from '../../../baseComponent/select/list'
import './index.less'
import Dropdown from '../../../baseComponent/dropdown'
import Icon from '../../icon'
import { findItemByValue } from '../../../baseComponent/select/util'

export default (props) => {
  const { multi, onChange, placement,
    ulStyle, overlayStyle, trigger, container, listClassName, ...otherProps } = props
  const List = multi ? SelectList.Multi : SelectList
  const Display = multi ? SelectDisplay.Multi : SelectDisplay
  const [visible, setVisible] = useState(false)
  const onOk = (val, item) => {
    onChange && onChange(val, item)
    setVisible(false)
  }
  const onClear = () => {
    if (multi) {
      onChange && onChange([])
    } else {
      onChange && onChange(null)
    }
    setVisible(false)
  }

  return <Dropdown
    getPopupContainer={triggerNode => container || triggerNode}
    overlayStyle={overlayStyle}
    trigger={trigger}
    overlay={<List
      {...otherProps}
      onChange={onOk}
      onOk={onOk}
      onClear={onClear}
      visible={visible}
      className={classNames({ 'mn-filter2-meinian-select': !multi }, listClassName)}
      style={ulStyle}
    />}
    visible={visible}
    onVisibleChange={_visible => setVisible(_visible)}
    placement={placement}
    disabled={otherProps.disabled}
  >
    <div><Display {...otherProps} visible={visible} onClear={onClear} /></div>
  </Dropdown>
}

export const SelectDisplay = (props) => {
  const { className, displayStyle, value = null, data = [], placeholder = '请选择', visible, disabled, onClear, allowClear = true, prefix } = props
  return <span
    className={classNames(
      'mn-filter2-meinian-select-display',
      className,
      {
        visible,
        active: (value || value === 0) && allowClear,
        disabled
      }
    )}
    style={displayStyle}
  >
    {
        data.find(m => value === m.value)?.label ? <span className="mn-filter2-line-1">{prefix}{data.find(m => value === m.value)?.label}</span>
          : <span className="mn-filter2-placeholder">{placeholder}</span>
    }
    {visible ? <Icon type="m-Vxing_shang" /> : <Icon type="m-Vxing_xia" />}
    {(value || value === 0) && allowClear && !disabled ? <Icon type="m-guanbi_tianchong" className="clear-icon" onClick={(e) => { e && e.stopPropagation(); onClear() }} /> : null}
  </span>
}

SelectDisplay.Multi = (props) => {
  const { className, displayStyle, value = [], data = [], disabled, placeholder = '请选择', visible, onClear } = props
  return <span
    className={classNames(
      'mn-filter2-meinian-select-display-multi',
      className,
      {
        visible,
        active: value.length,
        disabled
      }
    )}
    style={displayStyle}
  >
    {
        data.filter(m => value.includes(m.value))?.map(n => n.label)?.join(';')
          ? <span className="mn-filter2-line-1">{data.filter(m => value.includes(m.value))?.map(n => n.label)?.join(';')}</span>
          : <span className="mn-filter2-placeholder">{placeholder}</span>
    }
    {visible ? <Icon type="m-Vxing_shang" /> : <Icon type="m-Vxing_xia" />}
    {value.length && !disabled ? <Icon type="m-guanbi_tianchong" className="clear-icon" onClick={(e) => { e && e.stopPropagation(); onClear() }} /> : null}
  </span>
}

SelectDisplay.Level = (props) => {
  const { className, displayStyle, value = null, data = [], placeholder = '请选择', disabled, visible, onClear, prefix, onlyShowLeaf, showValueAsLabel } = props
  const text = () => {
    if (showValueAsLabel) return value
    const item = findItemByValue(value, data)
    if (!item) return null
    if (!item.parent) return item.label
    if (onlyShowLeaf) return item.label
    return `${item.parent.label}-${item.label}`
  }
  return <span
    className={classNames(
      'mn-filter2-meinian-select-display',
      className,
      {
        visible,
        active: value !== null,
        disabled
      }
    )}
    style={displayStyle}
  >
    {
        text() ? <span className="mn-filter2-line-1">{prefix}{text()}</span> : <span className="mn-filter2-placeholder">{placeholder}</span>
    }
    {visible ? <Icon type="m-Vxing_shang" /> : <Icon type="m-Vxing_xia" />}
    {value !== null && !disabled ? <Icon type="m-guanbi_tianchong" className="clear-icon" onClick={(e) => { e && e.stopPropagation(); onClear() }} /> : null}
  </span>
}
